import { Component, OnInit } from "@angular/core";
import { ModalController, ToastController, Platform } from "@ionic/angular";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { AuthService } from "src/app/services/auth.service";
import { CrudService } from "src/app/services/crud.service";
import { ResponseAPI } from "src/models/user.model";

@Component({
    selector: "app-modal-comment",
    templateUrl: "./modal-comment.page.html",
    styleUrls: ["./modal-comment.page.scss"],
    standalone: false
})
export class ModalCommentPage implements OnInit {
  form: UntypedFormGroup;

  constructor(
    public modal: ModalController,
    private fb: UntypedFormBuilder,
    private crud: CrudService,
    private auth: AuthService,
    public toast: ToastController,
    private platform: Platform
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      userId: [this.auth.user.id],
      mensagem: ["", [Validators.required]]
    });
  }

  close(): void {
    this.modal.dismiss();
  }

  async showToast(message: string) {
    const toast = await this.toast.create({
      message: message,
      duration: 2000,
      mode: this.platform.is("ios") ? "ios" : "md"
    });

    toast.present();
  }

  sendMessage() {
    if (this.form.invalid) {
      return false;
    }

    this.crud.postData("FaleConosco", null, this.form.value).subscribe(
      (response: ResponseAPI) => {
        if (response.success) {
          this.showToast("Your message has been sent successfully!");
          this.close();
        }
      },
      error => {
        this.showToast("An error occurred while sending your message.");
        this.close();
      }
    );
  }
}
